/*=========================================================================================
  File Name: sidebarItems.js
  Description: Sidebar Items list. Add / Remove menu items from here.
  Strucutre:
          url     => router path
          name    => name to display in sidebar
          slug    => router path name
          icon    => Feather Icon component/icon name
          tag     => text to display on badge
          tagColor  => class to apply on badge element
          i18n    => Internationalization
          submenu   => submenu of current item (current item will become dropdown )
                NOTE: Submenu don't have any icon(you can add icon if u want to display)
          isDisabled  => disable sidebar item/group
  ----------------------------------------------------------------------------------------
==========================================================================================*/

import moment from "moment-business-days";

export default [
  {
    header: 'Achiziții',  // Purchases
    icon: 'LayersIcon',
    i18n: 'Achiziții',
    items: [
      {
        url: '/efacturalist-ing',
        tagColor: 'primary',
        icon: 'GlobeIcon',
        name: 'eFactura',
        slug: 'eFactura',
        i18n: 'eFactura',
      },
      {
        url: '/outlay/outlay-list',  // son ancienne page d'accueil
        tagColor: 'primary',
        icon: 'CreditCardIcon',
        name: 'Cheltuieli',  // Expenses
        slug: 'Cheltuieli',
        i18n: 'Cheltuieli',
      }
    ]
  },
  {
    header: 'Vânzări',  // Sales
    icon: 'LayersIcon',
    i18n: 'Vânzări',
    items: [
      {
        url: '/invoice/invoice-list',
        tagColor: 'primary',
        icon: 'UploadIcon',
        name: 'Facturi',  // Invoices
        slug: 'Facturi',
        i18n: 'Facturi'
      },
      {
        url: '/efacturalist-out',
        tagColor: 'primary',
        icon: 'GlobeIcon',
        name: 'eFactura',
        slug: 'eFactura',
        i18n: 'eFactura',
      }
    ]
  },
  {
    header: 'Operațiuni',  // Operations
    icon: 'LayersIcon',
    i18n: 'Operațiuni',
    items: [
      {
        url: '/reception/reception-list',
        tagColor: 'primary',
        icon: 'DownloadIcon',
        name: 'Recepții',  // Receptions
        slug: 'Recepții',
        i18n: 'Recepții'
      },
      {
        url: '/production/production-list',
        tagColor: 'primary',
        icon: 'ZapIcon',
        name: 'Producție',  // Production
        slug: 'Producție',
        i18n: 'Producție'
      },
    ],
  },
  {
    header: 'Stoc',  // Stock
    icon: 'LayersIcon',
    i18n: 'Stoc',
    items: [
      {
        url: '/stock/stock-list',
        name: 'Stoc',  // Stock
        tagColor: 'primary',
        icon: 'PackageIcon',
        i18n: 'Stoc',
      },
    ],
  },
  {
    header: 'Rapoarte',  // Reports
    icon: 'LayersIcon',
    i18n: 'Rapoarte',
    items: [
      {
        url: '/reports/centralizator',
        name: 'Centralizator',  // Centralizator intrări – ieșiri – producție
        slug: 'Centralizator',
        tagColor: 'primary',
        icon: 'BarChart2Icon',
        i18n: 'Centralizator',
      },
    ],
  }
]